<template>
  <form @submit.prevent="search" class="search__form">
    <div class="search__input">
      <input @input.prevent="inputPrev" class="search__input-input" type="text" v-model="value" placeholder="Поиск">
      <input class="search__input-btn" type="submit" value=""/>
    </div>
    <div class="search__hint">
      <a v-for="(suggest, index) in suggestions" :key="index" class="search__hint-item" :href="getUrl(suggest)" v-html="getFormattedSuggest(suggest)"></a>
    </div>
  </form>
</template>

<script>
import tools from "@/components/mixins/tools";

export default {
  name  : "SearchInput",
  props : ["query"],
  data()
  {
    return {
      value              : "",
      suggestions        : [],
      valid_query        : "",
      validation_process : false
    };
  },
  mixins  : [tools],
  methods : {
    search()
    {
      if(!this.value) return;
      if(this.validation_process)
      {
        this.time = 1;
        this.debounce(this.search, 1000, true);
      }
      else
      {
        window.location.href = "/search/?q=" + this.valid_query + "&s=Поиск";
      }
    },
    getUrl( val )
    {
      return "/search/?q=" + val + "&s=Поиск";
    },
    async getValidQuery()
    {
      this.suggestions = [];
      let formData     = new FormData();
      formData.append("query", this.value);
      await fetch("/api/search_query/", {
        method : "POST",
        body   : formData
      })
      .then(response => response.json())
      .then(async resp =>
      {
        if(resp.success === true)
        {
          this.valid_query = resp.data["valid_query"];
          for(let val of resp.data["suggestions"])
            this.suggestions.push(val);
          this.validation_process = false;
        }
      });
    },
    async inputPrev()
    {
      await this.makeValidProcess();
      await this.debounce(this.getValidQuery, 200);
    },
    getFormattedSuggest( val )
    {
      let index      = val.indexOf(this.valid_query, 0);
      let length     = this.valid_query.length;
      let firstPart  = val.substring(index, length);
      let secondPart = val.substring(index + length);
      return "<b>" + firstPart + "</b>" + secondPart;
    },
    makeValidProcess()
    {
      this.validation_process = true;
    }
  },
  created()
  {
    this.value       = this.query ? this.query : "";
    this.valid_query = this.query ? this.query : "";
  }
};
</script>

<style scoped>

</style>